<script>
export default {
  data() {
    return {
      mobileHeaderBackBtn: false,
      showMobileHeaderPremiumPartner: null,
      showMobileHeaderNoPartner: null,
      mobileHeaderSubtitle: null,
      selectionType: null,
      isAstroRoute: false,
      isAnbieterMapApp: false,
    };
  },
  methods: {
    goBackMobileCheckout() {
      let data;
      if (this.showMobileHeaderNoPartner) {
        data = {
          storeType: "nopartner",
        };
      } else if (this.showMobileHeaderPremiumPartner) {
        data = {
          storeType: "pPartner",
        };
      }
      this.$root.$emit("mobile-checkout-back", data);
    },
  },
  mounted() {
    // Check if is an Astro page
    const metas = document.querySelectorAll("meta[name='generator']");
    this.isAstroRoute = [...metas].some((meta) =>
      meta.content.includes("Astro")
    );

    window.history.pushState(null, null, window.location.href);
    window.onpopstate = () => {
      if (
        this.showMobileHeaderNoPartner ||
        this.showMobileHeaderPremiumPartner
      ) {
        history.forward();
        this.historyCnt++;
        if (this.historyCnt == 2) {
          this.goBackMobileCheckout();
          this.historyCnt = 0;
        }
      }
    };

    if (!this.isAstroRoute) {
      // This code don't work on Astro -> `this.$root.$on` is not defined
      this.$root.$on("mobile-checkout", async (data) => {
        if (data.storeType === "nopartner") {
          if (!data.isOpened) {
            this.showMobileHeaderNoPartner = false;
          } else {
            this.showMobileHeaderNoPartner = true;
            this.mobileHeaderSubtitle = data.title;
            if (data.lastStep) {
              this.mobileHeaderBackBtn = false;
            } else {
              this.mobileHeaderBackBtn = true;
            }
          }
        } else if (data.storeType === "pPartner") {
          if (!data.isOpened) {
            this.showMobileHeaderPremiumPartner = false;
          } else {
            this.showMobileHeaderPremiumPartner = true;
            this.mobileHeaderSubtitle = data.title;
            if (data.lastStep) {
              this.mobileHeaderBackBtn = false;
            } else {
              this.mobileHeaderBackBtn = true;
            }
          }
        }
      });
      this.$root.$on("load-selection-type", async (type) => {
        this.selectionType = type;
      });

      if (this.$route.name === "AnbieterMapApp") {
        this.isAnbieterMapApp = true;
      }
    }
  },
  watch: {
    // watch route changes
    $route(to) {
      if (to.name !== "AnbieterMapApp") {
        this.showMobileHeaderPremiumPartner = false;
        this.showMobileHeaderNoPartner = false;
        this.isAnbieterMapApp = false;
      } else {
        this.isAnbieterMapApp = true;
      }
    },
    // watch isAnbieterMapApp changes and update navbar shadow
    isAnbieterMapApp(val) {
      const navbarEl = document.querySelector(".anni-navbar");
      if (!navbarEl) return;

      if (val) {
        navbarEl.style.boxShadow = "none";
      } else {
        navbarEl.style.boxShadow = "0 0 20px 7px #00000012";
      }
    },
  },
};
</script>

<template>
  <div
    class="anbieter-finder-sub-header"
    v-if="
      showMobileHeaderNoPartner === true ||
      showMobileHeaderPremiumPartner === true
    "
  >
    <div
      class="m-h-icon"
      v-if="mobileHeaderBackBtn"
      @click="goBackMobileCheckout()"
    >
      <img
        class="arrow-down-icon"
        src="../../../assets/images/arrow-down-icon.webp"
        alt="Chevron-Down icon"
      />
    </div>
    <div class="m-h-title">{{ mobileHeaderSubtitle }}</div>
  </div>
</template>

<style scoped lang="scss">
.anbieter-finder-sub-header {
  margin-top: 0;
  position: relative;
  height: 34px;
  background: white;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  .m-h-icon {
    position: absolute;
    height: 100%;
    width: 48px;
    left: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .arrow-down-icon {
      width: 14px;
      transform: rotate(90deg);
    }
  }

  .m-h-title {
    font-weight: 600;
    font-size: 14px;
    line-height: 1.5;
    text-align: center;
    color: #000;
  }
}

@media (min-width: 961px) {
  .anbieter-finder-sub-header {
    display: none;
  }
}
</style>
